package com.hyperether.goodjob.scenes.contacts

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.requiredHeight
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.selection.DisableSelection
import androidx.compose.material.Divider
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.style.TextOverflow
import androidx.lifecycle.Lifecycle
import androidx.lifecycle.compose.LifecycleEventEffect
import androidx.navigation.NavHostController
import com.hyperether.goodjob.boxCornerShape
import com.hyperether.goodjob.models.Site
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.add_a_contact
import com.hyperether.goodjob.resources.address
import com.hyperether.goodjob.resources.all_contacts
import com.hyperether.goodjob.resources.contact_name_and_type
import com.hyperether.goodjob.resources.contacts
import com.hyperether.goodjob.resources.email_capital
import com.hyperether.goodjob.resources.industry
import com.hyperether.goodjob.resources.no_contacts_available
import com.hyperether.goodjob.resources.phone_number
import com.hyperether.goodjob.resources.site
import com.hyperether.goodjob.scenes.components.WebFilterButton
import com.hyperether.goodjob.scenes.components.WebSearchField
import com.hyperether.goodjob.scenes.components.WebViewHeader
import com.hyperether.goodjob.scenes.contacts.components.ContactListWeb
import com.hyperether.goodjob.theme.BorderColor
import com.hyperether.goodjob.theme.DashboardBg
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import com.hyperether.goodjob.webDetailsTitle
import com.hyperether.resources.stringResource

@Composable
fun ContactsWeb(
    navController: NavHostController,
    viewModel: ContactsViewModel,
    sites: List<Site>,
    onFilterClick: () -> Unit
) {

    LifecycleEventEffect(Lifecycle.Event.ON_RESUME) {
        viewModel.loadRemoteData()
    }

    val searchQuery = remember { mutableStateOf("") }

    LaunchedEffect(Unit) {
        viewModel.init()
    }

    Column(
        modifier = Modifier
            .fillMaxSize()
            .background(DashboardBg)
    ) {
        WebViewHeader(
            isAddNewJob = false,
            isBackAvailable = false,
            isAddNewContact = true,
            title = stringResource(Res.string.contacts),
            isImportAndAddVisible = !viewModel.isEmployee(),
            navHostController = navController
        )
//        Spacer(modifier = Modifier.height(15.toScaleDp()))
        Column(
            modifier = Modifier
                .fillMaxSize()
                .padding(horizontal = 75.toScaleDp(), vertical = 15.toScaleDp())
                .background(Color.White, shape = boxCornerShape())
                .border(
                    width = 1.toScaleDp(),
                    shape = boxCornerShape(),
                    color = BorderColor
                )
        ) {
            Row(
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier
                    .height(webDetailsTitle())
                    .clip(
                        shape = RoundedCornerShape(
                            topStart = 4.toScaleDp(),
                            topEnd = 4.toScaleDp()
                        )
                    )
                    .background(color = Color.White)
                    .padding(horizontal = 23.toScaleDp())
            ) {
                Text(
                    modifier = Modifier.weight(2f),
                    text = stringResource(Res.string.all_contacts),
                    fontSize = 24.toScaleSp(),
                    fontWeight = FontWeight.W700,
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )

                WebSearchField(
                    text = searchQuery.value,
                    onTextChange = {
                        searchQuery.value = it
                    }
                )
                Spacer(modifier = Modifier.width(16.toScaleDp()))

                if (viewModel.contacts.value.isNotEmpty()) {
                    WebFilterButton(
                        onClick = {
                            onFilterClick()
                        }
                    )
                    Spacer(modifier = Modifier.width(16.toScaleDp()))
                }

                // TODO: get options
//                            DropdownSortBy(
//                                shouldAppendSortBy = false,
//                                items = listOf("Newest"),
//                                selectedValue =  "Newest",
//                                onValueSelected = {  },
//                                displayText = { "Sort by: $it" },
//                                placeholderColor = BorderColor,
//                                textColor = Color.Black,
//                                modifier = Modifier.height(Dp(55f))
//                            )
            }

            Row(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = 24.toScaleDp())
                    .requiredHeight(38.toScaleDp()),
                verticalAlignment = Alignment.CenterVertically
            ) {
                Text(
                    text = stringResource(Res.string.contact_name_and_type),
                    modifier = Modifier.weight(0.9f),
                    fontWeight = FontWeight.W700,
                    fontSize = 14.toScaleSp(),
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
                Text(
                    text = stringResource(Res.string.email_capital),
                    modifier = Modifier.weight(1.2f),
                    fontWeight = FontWeight.W700,
                    fontSize = 14.toScaleSp(),
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
                Text(
                    text = stringResource(Res.string.address),
                    modifier = Modifier.weight(1.2f),
                    fontWeight = FontWeight.W700,
                    fontSize = 14.toScaleSp(),
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
                Text(
                    text = stringResource(Res.string.phone_number),
                    modifier = Modifier.weight(0.8f),
                    fontWeight = FontWeight.W700,
                    fontSize = 14.toScaleSp(),
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
                Text(
                    text = stringResource(Res.string.industry),
                    modifier = Modifier.weight(0.7f),
                    fontWeight = FontWeight.W700,
                    fontSize = 14.toScaleSp(),
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
                Text(
                    text = stringResource(Res.string.site),
                    modifier = Modifier.weight(0.5f),
                    fontWeight = FontWeight.W700,
                    fontSize = 14.toScaleSp(),
                    maxLines = 1,
                    overflow = TextOverflow.Ellipsis
                )
            }
            val filteredContactsSearch = if (searchQuery.value.isNotBlank()) {
                viewModel.contactList.filter { contact ->
                    contact.name?.contains(
                        searchQuery.value,
                        ignoreCase = true
                    ) == true || contact.personName?.contains(
                        searchQuery.value, ignoreCase = true
                    ) == true || contact.addressObject?.address?.contains(
                        searchQuery.value, ignoreCase = true
                    ) == true
                }
            } else {
                viewModel.contactList
            }
            val sortedList = filteredContactsSearch.sortedBy { contact ->
                (contact.name ?: contact.email)?.lowercase()
            }
            Divider(
                modifier = Modifier.height(1.toScaleDp())
                    .background(Color.LightGray.copy(alpha = 0.1f))
            )
            if (sortedList.isEmpty()) {
                androidx.compose.material3.Text(
                    text = stringResource(Res.string.no_contacts_available),
                    color = Color.Black,
                    fontSize = 24.toScaleSp(),
                    textAlign = TextAlign.Center,
                    fontWeight = FontWeight.Bold,
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(
                            top = 60.toScaleDp(),
                            start = 16.toScaleDp(),
                            end = 16.toScaleDp()
                        )
                )
                androidx.compose.material3.Text(
                    text = stringResource(Res.string.add_a_contact),
                    color = Color.Gray,
                    textAlign = TextAlign.Center,
                    fontSize = 16.toScaleSp(),
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(
                            top = 20.toScaleDp(),
                            start = 16.toScaleDp(),
                            end = 16.toScaleDp()
                        )
                )
            } else {
                DisableSelection {
                    ContactListWeb(
                        sortedList,
                        navHostController = navController,
                        searchQuery,
                        sites
                    )
                }
            }
        }
    }
}